import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Valentina R.',
  city: 'Rosario'
}, {
  name: 'Luciana M.',
  city: 'Mendoza'
}, {
  name: 'Florencia G.',
  city: 'Tucumán'
}, {
  name: 'Romina P.',
  city: 'Paraná'
}, {
  name: 'Agustina D.',
  city: 'Salta'
}, {
  name: 'Camila T.',
  city: 'Neuquén'
}, {
  name: 'Daniela F.',
  city: 'Posadas'
}, {
  name: 'Sofía B.',
  city: 'Resistencia'
}, {
  name: 'Antonella V.',
  city: 'La Plata'
}, {
  name: 'Belén O.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta C.',
  city: 'San Juan'
}, {
  name: 'Micaela H.',
  city: 'Bariloche'
}, {
  name: 'Paula E.',
  city: 'Santiago del Estero'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 2;
}
function getRandomIndex(exclude: number) {
  let next = Math.floor(Math.random() * PURCHASES.length);
  while (next === exclude && PURCHASES.length > 1) {
    next = Math.floor(Math.random() * PURCHASES.length);
  }
  return next;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(() => Math.floor(Math.random() * PURCHASES.length));
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    const initial = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const hide = setTimeout(() => {
      setVisible(false);
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => getRandomIndex(prev));
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, 3000);
      return () => clearTimeout(showNext);
    }, 4000);
    return () => clearTimeout(hide);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-187">
      <div className="bg-[#1a1f3d] border border-[#d4af37]/20 rounded-xl p-3.5 shadow-lg" data-id="element-188">
        <div className="flex items-start gap-3" data-id="element-189">
          <div className="w-9 h-9 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/30 flex items-center justify-center flex-shrink-0" data-id="element-190">
            <span className="text-sm" data-id="element-191">✨</span>
          </div>
          <div className="min-w-0" data-id="element-192">
            <p className="text-[#f5f1e6] text-sm font-semibold leading-tight" data-id="element-193">
              {purchase.name}
              <span className="text-[#cbd0e0] font-normal" data-id="element-194"> de </span>
              <span className="text-[#d4af37]" data-id="element-195">{purchase.city}</span>
            </p>
            <p className="text-[#cbd0e0] text-xs mt-0.5" data-id="element-196">
              adquirió la{' '}
              <span className="text-[#f5f1e6] font-semibold" data-id="element-197">
                Formación en Astrología
              </span>
            </p>
            <p className="text-[#8b91ad] opacity-80 text-[10px] mt-1" data-id="element-198">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}